import React, { CSSProperties } from 'react';

type IconProps = {
  w?: number;
  h?: number;
  style?: CSSProperties;
  className?: string;
  fill?: string;
};

const MoonIcon = ({ w = 16, h = 16, style, fill, className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 16 16"
      className={className}
      style={style}
      fill={fill}
    >
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.64121 4.18704C6.64121 3.46783 6.78803 2.78289 7.05336 2.16054C7.06643 2.11507 7.07343 2.06705 7.07343 2.01739C7.07343 1.73164 6.84167 1.5 6.55578 1.5C6.51143 1.5 6.46838 1.50557 6.4273 1.51606C4.12704 2.42579 2.5 4.66867 2.5 7.29136C2.5 10.7203 5.28112 13.5 8.71181 13.5C11.3192 13.5 13.5513 11.8944 14.4726 9.61846C14.4903 9.56616 14.5 9.5101 14.5 9.45179C14.5 9.16604 14.2682 8.9344 13.9823 8.9344C13.9223 8.9344 13.8646 8.94463 13.811 8.96343C13.1975 9.21949 12.5241 9.36091 11.8177 9.36091C8.95881 9.36091 6.64121 7.04449 6.64121 4.18704Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default MoonIcon;
